import { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next'; // <-- Импорт i18next

import { useFetchUser } from '@shared/hooks';

import useAxios from '@services/api';

import { FormInputs } from './login.types';


export const useLogin = () => {
  const { t } = useTranslation(); // <-- Хук для получения переводов
  
  const [userData, fetchUser] = useFetchUser();

  // Не делаем автоматический запрос при загрузке страницы логина

  const { response, error, issueRequest, loading, statusCode } =
    useAxios<Record<string, never>>();

  const [loginError, setLoginError] = useState<{ [message: string]: string }>({
    message: '',
  });

  const handleSubmit = useCallback((data: FormInputs) => {
    void issueRequest({ url: `/login`, method: 'post', body: data });
  }, [issueRequest]);

  // Обработка ошибок из useAxios
  useEffect(() => {
    if (error) {
      console.log('Login error from useAxios:', error);
      setLoginError({ message: error });
    }
  }, [error]);

  useEffect(() => {
    if (!statusCode || loading) {
      return;
    }

    console.log('Effect', statusCode);

    if (statusCode === 200) {
      console.log('🔍 Login successful, fetching user data...');
      try {
        // Небольшая задержка перед запросом данных пользователя
        setTimeout(() => {
          fetchUser(true); // Принудительно получаем данные пользователя после успешного входа
        }, 100);
      } catch (error) {
        console.error('Error fetching user data:', error);
        setLoginError({ message: t('login.error') });
      }
    }

    if (statusCode === 401) {
      setLoginError({ message: t('login.wrongKey') });
    }

    if (statusCode === 403) {
      setLoginError({ message: t('login.keyExpired') });
    }

    if (statusCode === 429) {
      setLoginError({ message: t('login.tooManyRequests') });
    }
  }, [statusCode, response, loading, t]);

  return [response, handleSubmit, loading, loginError] as const;
};
